import { render, staticRenderFns } from "./BaseTitle.vue?vue&type=template&id=6dc9410e&scoped=true&"
import script from "./BaseTitle.vue?vue&type=script&lang=js&"
export * from "./BaseTitle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dc9410e",
  null
  
)

export default component.exports